import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6082de27"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "icon-container" };
const _hoisted_2 = { class: "button-description" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['mb-1 px-0 btn-forma-pagamento', $props.isActive ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event) => ($setup.setFormaPagamento($props.forma)))
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("i", {
                class: _normalizeClass($setup.buttonIcon)
            }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_2, _toDisplayString($props.forma.descricao), 1)
    ], 2));
}
